import { Token, ChainId } from 'vvs-sdk'
import BigNumber from 'bignumber.js'
import { BIG_ZERO } from 'utils/bigNumber'
import { IgoStatus } from 'views/Igos/types'
import tokens from './tokens'
import farms from './farms'
import { Igo } from './types'

const chainId = parseInt(process.env.REACT_APP_CHAIN_ID)
const vvsCroFarm = farms.find(
  (farm) => farm.token.symbol === tokens.vvs.symbol && farm.quoteToken.symbol === tokens.wcro.symbol,
)
const vvsCroLpToken = new Token(chainId, vvsCroFarm.lpAddresses[chainId], 18, vvsCroFarm.lpSymbol)

export const CURRENT_IGO_ID = 'corgiAI'
export const PROMOTIONAL_BANNER_IGO_ID = 'corgiAI'

// gold digger quest target
const VVSGOTCHI_IGO_ID_MAINNET = 'corgiAI'
const VVSGOTCHI_IGO_ID_TESTNET = 'ful'
export const VVSGOTCHI_IGO_ID =
  process.env.REACT_APP_CHAIN_ID === ChainId.MAINNET.toString() ? VVSGOTCHI_IGO_ID_MAINNET : VVSGOTCHI_IGO_ID_TESTNET

export const DEFAULT_IGO_SALE_DURATION = 24 * 60 * 60 * 1000 // ms

const staticDataIgos: Igo[] = [
  // {
  //   type: 'static',
  //   version: 'v2',
  //   id: 'argo',
  //   address: '0x0000000000000000000000000000000000000000', // FIXME: placeholder address for IGO contract, change once known
  //   isActive: true,
  //   cover: {
  //     name: '',
  //     color: '#FFFFFF',
  //     logoSize: 160,
  //     logoExtension: 'png',
  //     logoUrl: 'https://ferroprotocol.com/',
  //     articleUrl: 'https://medium.com/vvs-finance/ferro-protocol-is-launching-on-vvs-launchpad-igo-99e665be7851',
  //   },
  //   poolBasic: {
  //     saleAmount: '25,000,000',
  //     raiseAmount: '250000',
  //     distributionRatio: 1,
  //   },
  //   limitPerUserInLPUSD: '500',
  //   currency: tokens.vvs,
  //   token: tokens.ferro,
  //   tokenOfferingPrice: 0.01,
  //   saleDate: '2022-06-08T12:00:00+00:00',
  //   stakeBefore: '2022-06-06T11:59:59+00:00',
  //   publicIgoData: {
  //     // template data to fit type criteria
  //     status: 'coming_soon' as IgoStatus,
  //     isPoolHidden: true,
  //     secondsUntilEnd: 0,
  //     secondsUntilStart: 0,
  //     progress: 5,
  //     endTimestamp: BIG_ZERO,
  //     startTimestamp: BIG_ZERO,
  //     currencyPriceInUSD: BIG_ZERO,
  //     fetchIgoData: null,
  //     poolBasic: {
  //       raisingAmountPool: BIG_ZERO,
  //       offeringAmountPool: BIG_ZERO,
  //       limitPerUserInLP: new BigNumber(16983000000000000000000),
  //       taxRate: 0,
  //       totalAmountPool: BIG_ZERO,
  //       sumTaxesOverflow: BIG_ZERO,
  //       hasMaxOverflow: false,
  //       maxOverflow: new BigNumber(500),
  //       hasWhitelist: false,
  //       merkleRoot: '',
  //     },
  //   },
  //   walletIgoData: {
  //     // template data to fit type criteria
  //     poolBasic: {
  //       amountTokenCommittedInLP: BIG_ZERO,
  //       offeringAmountInToken: BIG_ZERO,
  //       refundingAmountInLP: BIG_ZERO,
  //       taxAmountInLP: BIG_ZERO,
  //       hasClaimed: false,
  //       isPendingTx: false,
  //     },
  //     allowance: BIG_ZERO,
  //     contract: null,
  //     setPendingTx: null,
  //     setIsClaimed: null,
  //     fetchIgoData: null,
  //     setIsRefunded: null,
  //   },
  //   vestingData: { // keep for FAQ sections
  //     mode: 'PARTIAL_VESTING',
  //     contract: null,
  //     token: tokens.argo,
  //     ratio: new BigNumber(90),
  //     cliff: BIG_ZERO,
  //     startTime: BIG_ZERO,
  //     interval: new BigNumber(2630000),
  //     duration: new BigNumber(23328000),
  //   },
  //   maxOverflow: 2 // for FAQ sections
  // },
]

const mainnetIgos: Igo[] = [
  // Latest Igos
  {
    type: 'smartContract',
    version: 'v2',
    id: 'corgiAI',
    address: '0x70BF9190C853D90e6849E616f67be3205064f4F5',
    isActive: true,
    cover: {
      name: '',
      color: '#FFFFFF',
      logoSize: 160,
      logoExtension: 'svg',
      logoUrl: 'https://corgiai.xyz/',
      articleUrl: 'https://medium.com/@MinerMole/corgiai-is-launching-on-vvs-launchpad-igo-47e1f7f4d76a',
    },
    poolBasic: {
      saleAmount: '1,000,000,000',
      raiseAmount: '30000',
      distributionRatio: 1,
    },
    limitPerUserInLPUSD: '100',
    currency: tokens.vvs,
    token: tokens.corgiai,
    tokenOfferingPrice: 0.00003,
    saleDate: '2023-06-07T09:00:00+00:00',
    stakeBefore: '2023-06-04T23:59:59+00:00',
    hideXvvsStakingHint: true,
    requirementsLine: 'Fulfil below TWO requirements to participate in the IGO:',
    vestingData: {
      // keep for FAQ sections
      mode: 'PARTIAL_VESTING',
      contract: null,
      token: tokens.corgiai,
      ratio: new BigNumber(70),
      cliff: BIG_ZERO,
      startTime: BIG_ZERO,
      interval: new BigNumber(2592000),
      duration: new BigNumber(18144000),
    },
    maxOverflow: 2, // for FAQ sections
  },
  {
    type: 'smartContract',
    version: 'v2',
    id: 'ful',
    displayName: 'Fulcrom',
    address: '0xaDA6eBa1595d8D5d678297698dA8B7ca1c6A61D3',
    isActive: false,
    cover: {
      name: '',
      color: '#FFFFFF',
      logoSize: 160,
      logoExtension: 'svg',
      logoUrl: 'https://fulcrom.finance/',
      articleUrl: 'https://medium.com/@MinerMole/fulcrom-is-launching-on-vvs-launchpad-igo-45e2965ee09f',
    },
    poolBasic: {
      saleAmount: '20,000,000',
      raiseAmount: '100000',
      distributionRatio: 1,
    },
    currency: tokens.vvs,
    token: tokens.ful,
    tokenOfferingPrice: 0.005,
    limitPerUserInLPUSD: '100',
    saleDate: '2023-03-16T09:00:00+00:00',
    stakeBefore: '2023-03-11T23:59:00+00:00',
    hideXvvsStakingHint: true,
    requirementsLine: 'Fulfil below TWO requirements to participate in the IGO:',
  },
  // Finished Igos
  {
    type: 'smartContract',
    version: 'v2',
    id: 'ful-invalidated',
    displayName: 'Fulcrom',
    address: '0xF141Ca49692d7cA580983A8070DA4782BC3e1aaA',
    invalidatedRefundAddress: '0x3a00a9e80865a8D65D057fB91cD6664814466027',
    isActive: false,
    cover: {
      name: 'Invalidated',
      noLogo: true,
      color: '#FFFFFF',
      logoSize: 160,
      logoExtension: 'svg',
      logoUrl: 'https://fulcrom.finance/',
      articleUrl: 'https://medium.com/@MinerMole/fulcrom-is-launching-on-vvs-launchpad-igo-45e2965ee09f',
    },
    poolBasic: {
      saleAmount: '20,000,000',
      raiseAmount: '100000',
      distributionRatio: 1,
    },
    currency: tokens.vvs,
    token: tokens.ful,
    tokenOfferingPrice: 0.005,
    limitPerUserInLPUSD: '100',
    saleDate: '2023-03-14T09:00:00+00:00',
    stakeBefore: '2023-03-11T23:59:00+00:00',
  },
  {
    type: 'smartContract',
    version: 'v2',
    id: 'veno',
    address: '0xd88477715240488207A78AF12866370572521F08',
    refundAddress: '0x7a1C86cDE132bCB3318A093Ca9439BF131b1901D',
    isActive: false,
    cover: {
      name: '',
      color: '#FFFFFF',
      logoSize: 160,
      logoExtension: 'svg',
      logoUrl: 'https://veno.finance/',
      articleUrl: 'https://medium.com/@MinerMole/veno-is-launching-on-vvs-launchpad-igo-92e5aaf264f8',
    },
    poolBasic: {
      saleAmount: '2,500,000',
      raiseAmount: '100000',
      distributionRatio: 1,
    },
    limitPerUserInLPUSD: '100',
    currency: tokens.vvs,
    token: tokens.vno,
    tokenOfferingPrice: 0.04,
    saleDate: '2023-01-17T09:00:00+00:00',
    stakeBefore: '2023-01-14T23:59:59+00:00',
  },
  {
    type: 'smartContract',
    version: 'v2',
    id: 'cronosid',
    address: '0x6363bd232075b7cFe56e1199Bd01B8449a785688',
    refundAddress: '0x086207c3a779259f6c2BF049938f8811EcFcB177',
    isActive: false,
    cover: {
      name: '',
      color: '#FFFFFF',
      logoSize: 160,
      logoExtension: 'svg',
      logoUrl: 'https://cronosid.xyz/',
      articleUrl: 'https://medium.com/vvs-finance/cronos-id-is-launching-on-vvs-launchpad-igo-4234d2596c26',
    },
    poolBasic: {
      saleAmount: '1,250,000',
      raiseAmount: '100000',
      distributionRatio: 1,
    },
    limitPerUserInLPUSD: '100',
    currency: tokens.vvs,
    token: tokens.croid,
    tokenOfferingPrice: 0.08,
    saleDate: '2022-11-09T09:00:00+00:00',
    stakeBefore: '2022-11-06T23:59:59+00:00',
  },
  {
    type: 'smartContract',
    version: 'v2',
    id: 'minted',
    address: '0xa43E50C3E8221D0065a6978Bb7cA90C6a0a3861F',
    isActive: false,
    refundAddress: '0xf675378e689afD85f41A12327A29706Ebab8E41f',
    cover: {
      name: '',
      color: '#FFFFFF',
      logoSize: 160,
      logoExtension: 'svg',
      logoUrl: '',
      articleUrl: 'https://medium.com/vvs-finance/minted-network-is-launching-on-vvs-launchpad-igo-dd107d1da164',
    },
    poolBasic: {
      saleAmount: '1,000,000',
      raiseAmount: '60000',
      distributionRatio: 1,
    },
    limitPerUserInLPUSD: '100',
    currency: tokens.vvs,
    token: tokens.mtd,
    tokenOfferingPrice: 0.06,
    saleDate: '2022-08-09T09:00:00+00:00',
    stakeBefore: '2022-08-06T23:59:59+00:00',
  },
  {
    type: 'smartContract',
    version: 'v2',
    id: 'ferro',
    address: '0xC4dC7c53bd7CD5Ba25eab7fA5a2b68499dfCb434', // FIXME: placeholder address for IGO contract, change once known
    isActive: false,
    cover: {
      name: '',
      color: '#FFFFFF',
      logoSize: 160,
      logoExtension: 'png',
      logoUrl: 'https://ferroprotocol.com/',
      articleUrl: 'https://medium.com/vvs-finance/ferro-protocol-is-launching-on-vvs-launchpad-igo-99e665be7851',
    },
    poolBasic: {
      saleAmount: '25,000,000',
      raiseAmount: '250000',
      distributionRatio: 1,
    },
    limitPerUserInLPUSD: '500',
    currency: tokens.vvs,
    token: tokens.ferro,
    tokenOfferingPrice: 0.01,
    saleDate: '2022-06-08T12:00:00+00:00',
    stakeBefore: '2022-06-06T11:59:59+00:00',
  },
  {
    type: 'smartContract',
    version: 'v1',
    id: 'argo',
    address: '0x7425FeFC5b1c6464eC8544279dFC1318165A0B9F',
    isActive: false,
    token: tokens.argo,
    cover: {
      name: 'ARGO',
      color: '#FFFFFF',
      logoUrl: 'https://www.argofinance.money/',
      articleUrl: 'https://medium.com/vvs-finance/argo-finance-partnership-and-launch-on-vvs-launchpad-igo-2a0c55ac102',
    },
    poolBasic: {
      saleAmount: '12,000,000 ARGO',
      raiseAmount: '600000',
      distributionRatio: 0.2,
    },
    poolUnlimited: {
      saleAmount: '48,000,000 ARGO',
      raiseAmount: '2400000',
      distributionRatio: 0.8,
    },
    currency: tokens.wcro,
    tokenOfferingPrice: 0.05,
    limitPerUserInLPUSD: '1000',
    saleDate: '2022-04-28T12:00:00+00:00',
    stakeBefore: '2022-04-26T23:59:59+00:00',
  },
  {
    type: 'smartContract',
    version: 'v1',
    id: 'versa',
    address: '0x99162C46B70CbEc9f124782988abC417A8721bfC',
    isActive: false,
    saleDate: '2022-04-12T12:00:00+00:00',
    cover: {
      name: 'VERSAGAMES',
      color: '#FFFFFF',
      logoUrl: 'https://versagames.io/',
      articleUrl: 'https://medium.com/vvs-finance/versagames-is-launching-on-vvs-launchpad-igo-6317979e929f',
    },
    poolBasic: {
      saleAmount: '6,000,000 VERSA',
      raiseAmount: '600000',
      distributionRatio: 0.3,
    },
    poolUnlimited: {
      saleAmount: '14,000,000 VERSA',
      raiseAmount: '1400000',
      distributionRatio: 0.7,
    },
    currency: vvsCroLpToken,
    token: tokens.versa,
    tokenOfferingPrice: 0.1,
    limitPerUserInLPUSD: '500',
  },
  {
    type: 'smartContract',
    version: 'v1',
    id: 'single',
    address: '0x96BEE0b9c83f3110896Ba24E711d15C3cD377612',
    isActive: false,
    cover: {
      name: 'SINGLE FINANCE',
      color: '#6f52e0',
      logoUrl: 'https://singlefinance.io/',
      articleUrl: 'https://medium.com/vvs-finance/single-finance-is-launching-on-vvs-launchpad-igo-de78507ee086',
    },
    poolBasic: {
      saleAmount: '5,000,000 SINGLE',
      raiseAmount: '250000',
      distributionRatio: 0.5,
    },
    poolUnlimited: {
      saleAmount: '5,000,000 SINGLE',
      raiseAmount: '250000',
      distributionRatio: 0.5,
    },
    currency: vvsCroLpToken,
    token: tokens.single,
    tokenOfferingPrice: 0.05,
    limitPerUserInLPUSD: '200',
  },
]

const testnetIgos: Igo[] = [
  // Latest Igos
  // Finished Igos
  {
    type: 'smartContract',
    version: 'v2',
    id: 'ful-invalidated',
    displayName: 'Fulcrom',
    address: '0x3F4cb509211A6B2dC2B1a5661E4Dedf541f8e4B0',
    invalidatedRefundAddress: '0xAec0158ffC192DfCd177928f438b9F39b39aa954',
    isActive: false,
    cover: {
      name: 'Invalidated',
      noLogo: true,
      color: '#FFFFFF',
      logoSize: 160,
      logoExtension: 'svg',
      logoUrl: 'https://fulcrom.finance/',
      articleUrl: 'https://medium.com/@MinerMole/fulcrom-is-launching-on-vvs-launchpad-igo-45e2965ee09f',
    },
    poolBasic: {
      saleAmount: '20,000,000',
      raiseAmount: '100000',
      distributionRatio: 1,
    },
    currency: tokens.vvs,
    token: tokens.ful,
    tokenOfferingPrice: 0.005,
    limitPerUserInLPUSD: '100',
    saleDate: '2023-03-06T03:14:35.000Z',
    saleEndDate: '2023-03-20T02:14:35.000Z',
    stakeBefore: '2023-03-11T23:59:00+00:00',
  },
  {
    type: 'smartContract',
    version: 'v2',
    id: 'cronosid',
    address: '0x8B97cd6a751b0037424Bd7E16b8637b8e5c6D0BD',
    refundAddress: '0xA25C52d0E83665c55BefC22307BD7E9A48c621B7',
    isActive: false,
    cover: {
      name: '',
      color: '#FFFFFF',
      logoSize: 160,
      logoExtension: 'svg',
      logoUrl: 'https://cronosid.xyz/',
      articleUrl: 'https://medium.com/vvs-finance/cronos-id-is-launching-on-vvs-launchpad-igo-4234d2596c26',
    },
    poolBasic: {
      saleAmount: '1,250,000',
      raiseAmount: '100000',
      distributionRatio: 1,
    },
    publicIgoData: {
      status: 'coming_soon' as IgoStatus,
      secondsUntilEnd: 1667893800,
      secondsUntilStart: 1667879400,
      progress: 5,
      endTimestamp: BIG_ZERO,
      startTimestamp: BIG_ZERO,
      currencyPriceInUSD: BIG_ZERO,
      fetchIgoData: null,
      poolBasic: {
        raisingAmountPool: new BigNumber(11043400000000000000000000),
        offeringAmountPool: new BigNumber(1250000000000000000000),
        limitPerUserInLP: new BigNumber(11043400000000000000000000),
        taxRate: 0,
        totalAmountPool: BIG_ZERO,
        sumTaxesOverflow: BIG_ZERO,
        hasMaxOverflow: true,
        maxOverflow: new BigNumber(200),
        hasWhitelist: true,
        merkleRoot: '0xd52e81b0bf430de7d24ad0c8c937172a151b75ee7f6b8240f3e2f5427504dba1',
      },
    },
    limitPerUserInLPUSD: '100',
    currency: tokens.vvs,
    token: tokens.croid,
    tokenOfferingPrice: 0.08,
    saleDate: '2022-11-08T11:50:00+08:00',
    stakeBefore: '2022-11-08T15:50:00+08:00',
    vestingData: {
      mode: 'PARTIAL_VESTING',
      contract: null,
      token: tokens.croid,
      ratio: new BigNumber(50),
      cliff: BIG_ZERO,
      startTime: BIG_ZERO,
      interval: new BigNumber(1800),
      duration: new BigNumber(10800),
    },
  },
  {
    type: 'smartContract',
    refundAddress: '0x333702f7D1c8bE131D7a1338B4262a3E15F2c654',
    version: 'v2',
    id: 'lion',
    address: '0xF22ba42d2056f227aD37Ea2BB7099997d53d3Ac9',
    isActive: false,
    token: tokens.lion,
    cover: {
      name: 'LION',
      color: '#FFFFFF',
      logoUrl: 'https://www.argofinance.money/',
      articleUrl: 'https://medium.com/vvs-finance/argo-finance-partnership-and-launch-on-vvs-launchpad-igo-2a0c55ac102',
    },
    poolBasic: {
      saleAmount: '24,000 LION',
      raiseAmount: '1200',
      distributionRatio: 0.2,
    },
    poolUnlimited: {
      saleAmount: '96,000 LION',
      raiseAmount: '4800',
      distributionRatio: 0.8,
    },
    currency: tokens.wcro,
    tokenOfferingPrice: 0.05,
    limitPerUserInLPUSD: '1000',
    saleDate: '2022-05-18T20:00:00+00:00',
    stakeBefore: '2022-05-19T11:59:59+00:00',
  },
  {
    type: 'smartContract',
    version: 'v1',
    id: 'argo',
    address: '0x2a59804792EDB39889aA144417c6437a48Fdf9fa',
    isActive: false,
    token: tokens.argo,
    cover: {
      name: 'ARGO',
      color: '#FFFFFF',
      logoUrl: 'https://www.argofinance.money/',
      articleUrl: 'https://medium.com/vvs-finance/argo-finance-partnership-and-launch-on-vvs-launchpad-igo-2a0c55ac102',
    },
    poolBasic: {
      saleAmount: '12,000,000 ARGO',
      raiseAmount: '600000',
      distributionRatio: 0.2,
    },
    poolUnlimited: {
      saleAmount: '48,000,000 ARGO',
      raiseAmount: '2400000',
      distributionRatio: 0.8,
    },
    currency: tokens.wcro,
    tokenOfferingPrice: 0.05,
    limitPerUserInLPUSD: '1000',
    saleDate: '2022-04-26T07:30:00+00:00',
    stakeBefore: '2022-04-26T23:59:59+00:00',
  },
  {
    // Simulate VersaGames
    type: 'smartContract',
    version: 'v1',
    id: 'versa',
    address: '0x009a5Ed7164E54B13618c976B1b87a9f7A380d61', // IGO vault address
    isActive: false,
    token: tokens.versa,
    cover: {
      name: 'VERSAGAMES',
      color: '#FFFFFF',
      logoUrl: 'https://versagames.io/',
      articleUrl: 'https://medium.com/vvs-finance/versagames-is-launching-on-vvs-launchpad-igo-6317979e929f',
    },
    poolBasic: {
      saleAmount: '6,000,000 VERSA',
      raiseAmount: '600',
      distributionRatio: 0.3,
    },
    poolUnlimited: {
      saleAmount: '14,000,000 VERSA',
      raiseAmount: '1400',
      distributionRatio: 0.7,
    },
    currency: vvsCroLpToken,
    tokenOfferingPrice: 0.1,
    limitPerUserInLPUSD: '500',
  },
  {
    // Simulate Single Finance
    type: 'smartContract',
    version: 'v1',
    id: 'seattle',
    address: '0xb8380816E3A13b717C701BE5e12E2aeC12FD23d5',
    isActive: false,
    cover: {
      name: 'Seattle',
      color: '#6f52e0',
      logoUrl: 'https://seattle.igo',
    },
    poolBasic: {
      saleAmount: '5,000,000 SEATTLE',
      raiseAmount: '250',
      distributionRatio: 0.5,
    },
    poolUnlimited: {
      saleAmount: '5,000,000 SEATTLE',
      raiseAmount: '250',
      distributionRatio: 0.5,
    },
    currency: vvsCroLpToken,
    token: tokens.seattle,
    tokenOfferingPrice: 0.00005,
    limitPerUserInLPUSD: '200',
  },
]

const igos: Igo[] =
  process.env.REACT_APP_CHAIN_ID === ChainId.MAINNET.toString()
    ? mainnetIgos.concat(staticDataIgos)
    : testnetIgos.concat(staticDataIgos)

export default igos
export const currentIgo = igos.find((igo) => igo.id === CURRENT_IGO_ID)
